// extracted by mini-css-extract-plugin
module.exports = {"container":"CarouselSlide_container__3p0CY","slideContainer":"CarouselSlide_slideContainer__29CdR"};